export type AssignmentSelectionType = 'email' | 'team' | null;

export interface AssignmentSelection {
    type: AssignmentSelectionType;
    value: string | null;
}

export function resolveAssignmentSelection(email: string | null, teamId: string | null): AssignmentSelection {
    if (email) {
        return { type: 'email', value: email };
    }
    if (teamId) {
        return { type: 'team', value: teamId };
    }
    return { type: null, value: null };
}
